<template>
  <div class="views">
    <router-link tag="div" :to="goToRoute(true)" v-slot="{ navigate }" v-if="settings.with_markers !== false">
      <ui-button
        class="views__markers"
        :class="{
          'views__markers--active':
            $route.name === 'markers' || $route.name === 'location' || $route.name === 'division',
        }"
        button="cta"
        icon="marker"
        :label="$t('views.markers')"
        @click="navigate"
      />
    </router-link>
    <router-link tag="div" :to="goToRoute(false)" v-slot="{ navigate }" v-if="settings.with_zone">
      <ui-button
        class="views__zones"
        :class="{ 'views__zones--active': $route.name === 'zones' || $route.name === 'divisionZones' }"
        button="cta"
        icon="zone"
        :label="$t('views.zones')"
        @click="navigate"
      />
    </router-link>
    <router-link
      tag="div"
      :to="{ name: 'markersIntention', params: { id: $route.params.id } }"
      v-slot="{ navigate }"
      v-if="settings.with_zone_intention === true"
    >
      <ui-button
        class="views__markers-intention"
        :class="{
          'views__markers-intention--active': $route.name === 'markersIntention',
        }"
        button="cta"
        icon="marker"
        :label="$t('views.markersIntention')"
        @click="navigate"
      />
    </router-link>
    <router-link
      tag="div"
      :to="{ name: 'zonesIntention', params: $route.params, query: $route.query }"
      v-slot="{ navigate }"
      v-if="settings.with_zone_intention === true"
    >
      <ui-button
        class="views__zones-intention"
        :class="{
          'views__zones-intention--active':
            $route.name === 'zonesIntention' || $route.name === 'divisionZonesIntention',
        }"
        button="cta"
        icon="zone"
        :label="$t('views.zonesIntention')"
        @click="navigate"
      />
    </router-link>
    <router-link
      v-if="settings.with_analytics !== false"
      tag="div"
      :to="{ name: 'analytics', params: $route.params, query: $route.query }"
      v-slot="{ navigate }"
    >
      <ui-button
        class="views__analytics"
        :class="{ 'views__analytics--active': $route.name === 'analytics' }"
        button="cta"
        icon="analytic"
        :label="$t('views.analytics')"
        @click="navigate"
      />
    </router-link>
  </div>
</template>

<script>
import UiButton from '@/components/UI/Button.vue'

export default {
  name: 'Views',
  components: {
    UiButton,
  },
  props: {
    settings: {
      type: Object,
      required: true,
    },
  },
  methods: {
    goToRoute(routeIsMarkers) {
      const routeLevel = this.$route.params.key
      if (routeLevel?.length > 0) {
        return {
          name: routeIsMarkers ? 'division' : 'divisionZones',
          params: { level: this.$route.params.level, key: this.$route.params.key },
          query: this.$route.query,
        }
      }
      return {
        name: routeIsMarkers ? 'markers' : 'zones',
        params: { id: this.$route.params.id },
        query: this.$route.query,
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.views {
  display: inline-flex;
  position: absolute;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 2;

  @media (min-width: $screen-sm) {
    right: initial;
    bottom: $gutter-md;
    left: $gutter-md;
    border-radius: $button-min-height-desktop / 2;
    box-shadow: $generic-box-shadow;
    overflow: hidden;
  }

  &__markers,
  &__markers-intention {
    @media (min-width: $screen-sm) {
      border-top-right-radius: 0;
      border-bottom-right-radius: 0;
    }
  }

  &__zones,
  &__zones-intention {
    border-right: 0;
    border-left: 0;
    border-radius: 0;
  }

  &__analytics {
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
  }

  &__markers,
  &__markers-intention,
  &__zones,
  &__zones-intention,
  &__analytics {
    box-shadow: none;
    width: 100%;

    &:hover:not(:disabled),
    &:focus:not(:disabled) {
      box-shadow: none;
    }

    &--active {
      border-color: map-get($generic-color-variants, 'gtr');
      background-color: map-get($generic-color-variants, 'gtr');
      color: $generic-color-text-alt;

      &:hover:not(:disabled),
      &:focus:not(:disabled) {
        border-color: map-get($generic-color-variants, 'gtr');
        box-shadow: none;
        background-color: map-get($generic-color-variants, 'gtr');
      }
    }
  }

  &__markers-intention,
  &__zones-intention {
    flex: 1 1 auto;
  }
}
</style>
<style lang="scss">
.views {
  &__markers,
  &__markers-intention,
  &__zones,
  &__analytics {
    @media (max-width: $screen-sm - 1) {
      flex: 1;
      flex-direction: column;
      border-radius: 0 !important;
      height: $gmap-views-height;
    }

    .ui-button {
      &__icon {
        @media (max-width: $screen-sm - 1) {
          margin-right: 0 !important;
          margin-bottom: 3px;
        }
      }

      &__label {
        @media (max-width: $screen-sm - 1) {
          font-size: $font-size-sm;
        }
      }
    }
  }
}
</style>
